import Vue from 'vue/dist/vue.esm';
import * as uiv from 'uiv';
import { I18nModule } from './i18n';

export class VueModule {

  /**
   * Définir les composantes VueJS ICI.
   */
  static components = {
    'date-picker': require('../components/DatePicker.vue').default,
    'task-manager': require('../components/taskmanager/TaskManager.vue').default,
    'timesheet': require('../components/timesheet/Timesheet.vue').default,
    'chatroom': require('../components/chatroom/Chatroom.vue').default,
  }

  /**
   * Initialise le module VueJS
   */
  static init() {

    Vue.use(uiv);

    for (const name in VueModule.components) {
      const component = VueModule.components[name];
      Vue.component(name, component);
    }
    
    Vue.mixin({
      methods: {
        L: (key, placeholders) => I18nModule.translate(key, placeholders),
        __: (key, placeholders) => I18nModule.translate(key, placeholders)
      },
      computed: {
        formatMoney() {
          return (value) => {
            return parseFloat(value).toFixed(2) + " $"
          }
        },
        formatDigit() {
          return (value, n = 2) => {
            if(value === null || value === undefined || value === '') return value;
            return parseFloat(value).toFixed(n)
          }
        },
        advancedFormat() {
          return (text) => {
            return window.advancedFormat(text);
          }
        }
      },
    })
    
  }

  /**
   * Rafraîchi les composantes VueJS dans le document.
   * @param {string} selector Sélecteur.
   */
  static refreshInDocument(selector) {

    if(selector === undefined) selector = "body";

    document.querySelectorAll(selector).forEach(el => {
      el.querySelectorAll(".vue-enabled").forEach(el2 => {
        var vm = new Vue({
          el: el2
        });
      })
    });

  }

}

window.refreshVue = (selector) => VueModule.refreshInDocument(selector);

window.onload = function(){
  VueModule.refreshInDocument();
}